import { EUserFlow } from '@/context/borrower';
import { EDisplays } from '@/context/display';
import { IPartnerParams } from '@/partners/partnerTypes';

export function getInitialDisplayScreen(partner: IPartnerParams): EDisplays {
    function mapInitialDisplay(userFlow: EUserFlow | undefined): EDisplays {
        const display = mapUserFlow(userFlow);
        if (
            display === EDisplays.QUICK_CALCULATOR &&
            partner.multiAssetJourney?.enabled
        ) {
            return EDisplays.MULTI_ASSET_JOURNEY;
        }
        return display;
    }

    if (partner.splitTest) {
        // flip a coin to decide which user flow to use
        const random = Math.random();
        if (random < 0.5) {
            return mapInitialDisplay(partner.userFlow);
        }

        return mapInitialDisplay(partner.splitTestUserFlow);
    }

    const noLender =
        partner.userFlow === EUserFlow.NO_LENDER ||
        partner.userFlow === EUserFlow.NO_LENDER_EARLY_SIGNUP;

    console.log('getInitialDisplayScreen', partner.showQuickQuote, noLender);

    if (!noLender && partner.showQuickQuote) {
        return mapInitialDisplay(partner.userFlow);
    } else {
        return EDisplays.NO_LENDER_HOME;
    }
}

function mapUserFlow(userFlow: EUserFlow | undefined): EDisplays {
    switch (userFlow) {
        case EUserFlow.TRUCKSTOP_NEW_SCREEN:
            return EDisplays.TRUCKSTOP_LANDING_PAGE;
        case EUserFlow.TEST_DRIVE:
            return EDisplays.TEST_DRIVE_LANDING_PAGE;
        case EUserFlow.TRUCKSTOP_NORMAL:
        case EUserFlow.NORMAL:
        case EUserFlow.EARLY_SIGNUP:
        default:
            return EDisplays.QUICK_CALCULATOR;
    }
}
